import * as actionTypes from "./constants";
import { combineReducers } from "redux";
import roomPickerReducer from "./roomPicker/reducer";
import dateRangePickerReducer from "./dateRangePicker/reducer";

const selectedCleanerReducer = (state = "", action) => {
  switch (action.type) {
    case actionTypes.SET_CLEANER:
      return action.cleaner;

    default:
      return state;
  }
};

const selectedCleaningReducer = (state = "", action) => {
  switch (action.type) {
    case actionTypes.LOAD_CLEANING_ID:
      return action.id;
    default:
      return state;
  }
};

const scheduleCleaningReducer = combineReducers({
  selectedCleaner: selectedCleanerReducer,
  selectedCleaning: selectedCleaningReducer,
  roomPicker: roomPickerReducer,
  dateRangePicker: dateRangePickerReducer
});
const rootReducer = (state, action) => {
  if (action.type === actionTypes.LOAD_FRESH) {
    state = undefined;
  }
  return scheduleCleaningReducer(state, action);
};

export default rootReducer;



// WEBPACK FOOTER //
// ./src/cleaning/schedule/reducer.js